
import { API_BASE_URL } from '../api/config';

export interface Plan {
    id: number;
    plan_id: string;
    name: string;
    price: number;
    speed: string;
    features: string[];
}

export interface Product {
    id: number;
    product_id: string;
    name: string;
    price: number;
    image: string;
    description: string;
    category: 'tech' | 'stationery';
    stock: number;
}

export interface Service {
    id: number;
    service_id: string;
    name: string;
    icon: string;
    sub_services: string[];
    price_text: string;
}

export const getPlans = async (): Promise<Plan[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/plans.php`);
        if (!response.ok) throw new Error('Failed to fetch plans');
        return await response.json();
    } catch (error) {
        console.error('Error fetching plans:', error);
        return [];
    }
};

export const getProducts = async (): Promise<Product[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/products.php`);
        if (!response.ok) throw new Error('Failed to fetch products');
        return await response.json();
    } catch (error) {
        console.error('Error fetching products:', error);
        return [];
    }
};

export const getServices = async (): Promise<Service[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/services.php`);
        if (!response.ok) throw new Error('Failed to fetch services');
        return await response.json();
    } catch (error) {
        console.error('Error fetching services:', error);
        return [];
    }
};

export interface Testimonial {
    id: number;
    name: string;
    text: string;
    verified: boolean;
}

export interface FAQ {
    id: number;
    question: string;
    answer: string;
}

export interface BlogPost {
    id: number;
    title: string;
    category: string;
    image: string;
    content?: string;
}

export const getTestimonials = async (): Promise<Testimonial[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/content.php?type=testimonials`);
        if (!response.ok) throw new Error('Failed to fetch testimonials');
        return await response.json();
    } catch (error) {
        console.error('Error fetching testimonials:', error);
        return [];
    }
};

export const getFaqs = async (): Promise<FAQ[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/content.php?type=faqs`);
        if (!response.ok) throw new Error('Failed to fetch faqs');
        return await response.json();
    } catch (error) {
        console.error('Error fetching faqs:', error);
        return [];
    }
};

export const getBlogPosts = async (): Promise<BlogPost[]> => {
    try {
        const response = await fetch(`${API_BASE_URL}/content.php?type=blog`);
        if (!response.ok) throw new Error('Failed to fetch blog posts');
        return await response.json();
    } catch (error) {
        console.error('Error fetching blog posts:', error);
        return [];
    }
};

export interface Order {
    customer_name: string;
    customer_phone: string;
    customer_address?: string;
    items: any[];
    total: number;
    store: 'tech' | 'stationery' | 'both';
}

export const createOrder = async (orderData: Order): Promise<{ success: boolean; id?: number; error?: string }> => {
    try {
        const response = await fetch(`${API_BASE_URL}/orders.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(orderData),
        });
        return await response.json();
    } catch (error) {
        console.error('Error creating order:', error);
        return { success: false, error: 'Network error' };
    }
};

export interface TicketData {
    name: string;
    email: string;
    phone: string;
    subject: string;
    message: string;
    action?: 'create_ticket';
}

export const createTicket = async (data: TicketData): Promise<{ success: boolean; ticket_id?: string; error?: string }> => {
    try {
        const response = await fetch(`${API_BASE_URL}/tickets.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...data, action: 'create_ticket' }),
        });
        return await response.json();
    } catch (error) {
        console.error('Error creating ticket:', error);
        return { success: false, error: 'Network error' };
    }
};
